/* eslint-disable no-unused-vars */
import apiClient from '@u/apiClient'
import UpdateDossierInfosController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierInfosController'
import UpdateDossierContactsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierContactsController'
import UpdateDossierBurialController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierBurialController'
import UpdateDossierOtherEventsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierOtherEventsController'
import UpdateDossierRemainsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierRemainsController'
import UpdateDossierInsuranceController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierInsuranceController'
import UpdateDossierParticularityController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierParticularityController'
import UpdateDossierFlowersDefaultsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierFlowersDefaultsController'
import UpdateDossierFinancingController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierFinancingController'
import UpdateDossierPublicationInfosController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierPublicationInfosController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

// state.dossier is a single object shared across all dossier tabs, and
// tasks/items get attached onto it separately (dossier_items/mutations.js,
// mutations.js) — including a live Pusher push unrelated to any tab the
// user is on. Section updates never need them, so strip them before
// sending to avoid an oversized payload breaking unrelated saves.
function sanitizeDossierForSectionUpdate(dossier) {
  if (!dossier) {
    return dossier
  }
  const { tasks, items, ...sanitizedDossier } = dossier
  return sanitizedDossier
}

// const base_errors = { deceased: {}, events: [] }
const base_errors = {}
export default {
  updateDossierInfos: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierInfosController.put({ dossier: payload.dossier_id }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          if (response.status === 200) {
            commit('setDossier', response.data.dossier)
            commit('setDossierMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // Resolves with { success: true } and commits nothing: callers re-fetch the
  // dossier through fetchDossierByID, like the burial and remains tabs. The
  // previous inline commit fed the summary from a narrower relation set than
  // dossier.get loads, and never refreshed the initial dossier baseline.
  updateDossierContacts: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierContactsController.put({ dossier: payload.dossier_id }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierBurial: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierBurialController.put({ dossier: payload.dossier_id }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierOtherEvents: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierOtherEventsController.put({
            dossier: payload.dossier_id
          }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierRemains: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierRemainsController.put({ dossier: payload.dossier_id }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierInsurance: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierInsuranceController.put({ dossier: payload.dossier_id }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          if (response.status === 200) {
            commit('setDossier', response.data.dossier)
            commit('setDossierMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierParticularities({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierParticularityController.put({
            dossier: payload.dossier_id
          }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          if (response.status === 200) {
            commit('setDossier', response.data.dossier)
            commit('setDossierMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // livraison et fournisseur par défaut des fleurs, en une seule requête
  updateDossierFlowersDefaults({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierFlowersDefaultsController.put({
            dossier: payload.dossier_id
          }),
          payload.defaults
        )
        .then((response) => {
          if (response.status === 200) {
            commit('setDossier', response.data.dossier)
            commit('setDossierMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierFinancing: ({ commit }, payload) => {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierFinancingController.put({ dossier: payload.dossier_id }),
          sanitizeDossierForSectionUpdate(payload.dossier)
        )
        .then((response) => {
          if (response.status === 200) {
            commit('setDossier', response.data.dossier)
            commit('setDossierMetadata', response.data.metadata)
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateDossierSiteInfos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierPublicationInfosController.put({
            dossier: payload.dossier.id
          }),
          sanitizeDossierForSectionUpdate(payload.dossier),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async updateDossierTasks({ commit }, payload) {
    await apiClient
      .put(`/api/dossier/update-task/${payload.dossier_id}`, payload.dossier)
      .then(async (response) => {
        if (response.status === 200) {
          commit('auth/setErrors', base_errors, { root: true })
          commit('setDossier', response.data.dossier)
          commit('setDossierMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('updateDossierParticularities', reason)
      })
  }
}
